import React from 'react';

const HomeOpenHours = () => {
  return (
    
    <section id="home-open-hours">
    <h1>Nyitvatartás</h1>

    <div id="home-hours-tables">

      <table>
        <caption>Központi iroda</caption>
        <tbody>
          <tr>
            <td>Hétfő</td>
            <td>7:30 - 18:00</td>
          </tr>
          
          <tr>
            <td>Kedd</td>
            <td>7:30 - 16:00</td>
          </tr>
          
          <tr>
            <td>Szerda</td>
            <td>7:30 - 16:00</td>
          </tr>
          
          <tr>
            <td>Csütörtök</td>
            <td>7:30 - 16:00</td>
          </tr>
          
          <tr>
            <td>Pénter</td>
            <td>7:30 - 13:30</td>
          </tr>
          
          <tr>
            <td>Szombat</td>
            <td>Zárva</td>
          </tr>
          
          <tr>
            <td>Vasárnap</td>
            <td>Zárva</td>
          </tr>
        </tbody>
      </table>

      <div className="vertical-line"></div>

      <table>
        <caption>Köztisztasági telep</caption>
        <tbody>
          <tr>
            <td>Hétfő</td>
            <td>8:00 - 11:00</td>
            <td>14:00 - 18:00</td>
          </tr>
          
          <tr>
            <td>Kedd</td>
            <td>8:00 - 11:00</td>
            <td>14:00 - 18:00</td>
          </tr>
          
          <tr>
            <td>Szerda</td>
            <td>8:00 - 11:00</td>
            <td>14:00 - 18:00</td>
          </tr>
          
          <tr>
            <td>Csütörtök</td>
            <td>8:00 - 11:00</td>
            <td>14:00 - 18:00</td>
          </tr>
          
          <tr>
            <td>Pénter</td>
            <td>8:00 - 11:00</td>
            <td>14:00 - 18:00</td>
          </tr>
          
          <tr>
            <td>Szombat</td>
            <td>7:00 - 8:00</td>
            <td>12:00 - 13:00</td>
          </tr>
          
          <tr>
            <td>Vasárnap</td>
            <td>7:00 - 8:00</td>
            <td></td>
          </tr>
        </tbody>
      </table>

      <div className="vertical-line"></div>
      
      <table>
        <caption>Hulladékkezelő telep</caption>
        <tbody>
          <tr>
            <td>Hétfő</td>
            <td>Zárva</td>
          </tr>
          
          <tr>
            <td>Kedd</td>
            <td>Zárva</td>
          </tr>
          
          <tr>
            <td>Szerda</td>
            <td>Zárva</td>
          </tr>
          
          <tr>
            <td>Csütörtök</td>
            <td>Zárva</td>
          </tr>
          
          <tr>
            <td>Pénter</td>
            <td>Zárva</td>
          </tr>
          
          <tr>
            <td>Szombat</td>
            <td>9:00 - 17:00</td>
          </tr>
          
          <tr>
            <td>Vasárnap</td>
            <td>Zárva</td>
          </tr>
        </tbody>

      </table>

    </div>

    <p>Ünnep- és munkaszüneti napokon zárva</p>
  </section>
  );
};

export default HomeOpenHours;